import { render, staticRenderFns } from "./BuildFirstFlowCard.vue?vue&type=template&id=7128e467&"
import script from "./BuildFirstFlowCard.vue?vue&type=script&lang=js&"
export * from "./BuildFirstFlowCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports